<template>
	<m-layout>
    <div fill-height class="fill-height" style="width:100%">
      <m-booking-edit-form :form="form" :booking="selectedItem" :dialog="dialog_edit" @update="onUpdateBooking" @close="onCloseBooking"></m-booking-edit-form>
      <m-invoice :dialog="dialog_invoice" :selectedItem="selectedInvoice" :filteredBookings="bookings" @close="onClose"></m-invoice>
      <v-dialog v-model="dialog_loader" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pt-3">
            Please stand by
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-card-title class="m-page__title">
        <span class="headline">Booqit Invoices </span>
          <v-btn icon class="mx-0" @click="onRefreshAll">
             <v-icon color="primary">refresh</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
         Total: {{ totalAmount | currency(true) }}
      </v-card-title>
      <v-layout wrap grid-list-md>
        <v-flex xs12 class="px-1">
          <v-card>
            <v-data-table
                v-bind:headers="headers"
                v-bind:items="booqitInvoices"
                :options.sync="pagination_invoices"
                :sort-by="['date']"
                :sort-desc="[true]"
                :footer-props="{ 'items-per-page-options': [5, 20, {text:'All', value:-1}] }"
              >
              <template v-slot:body="{ items }">
                <tbody>
                  <tr v-for="item in items" :key="item.id" @click="onSelect(item)">
                    <td >{{ item.date | date}}</td>
                    <td >{{ item.invoiceId }}</td>
                    <td >{{ item.amount }}</td>
                  </tr>
                </tbody>
              </template>
              <template slot="pageText" slot-scope="{ pageStart, pageStop }">
                From {{ pageStart }} to {{ pageStop }}
              </template>
            </v-data-table>
                            <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        top
        color="primary"
        height="2"
        light
      ></v-progress-linear>
          </v-card>

        </v-flex>

        <v-flex v-if="selectedInvoice.invoiceId && !loading" xs12 class="px-1">
          <v-card>
            <v-toolbar class="elevation-0" style="background: white">


              <v-toolbar-title> {{ selectedInvoice.date | date }} <span class="caption">({{ selectedInvoice.invoiceId }})</span></v-toolbar-title>
              <v-divider
                class="mx-2"
                inset
                vertical
              ></v-divider>
                <v-btn v-if="bookings.length" outlined color="primary" text style="background: white" @click.stop="onFactuurItem(selectedInvoice)">
                  Invoice <v-icon color="primary">receipt</v-icon>
                </v-btn>

                <v-dialog v-model="dialog_notFound" scrollable max-width="200">
                  <template v-slot:activator="{ on }">
                  <v-btn v-if="notFoundTransportIds.length" small color="primary" text style="background: white" v-on="on">
                    <v-icon color="primary">error_outline</v-icon>
                  </v-btn>
                  </template>
                  <v-card>
                    <v-list dense>
                      <v-subheader>Not found ({{notFoundTransportIds.length}})</v-subheader>
                      <v-list-item class="m-selectable" v-for="(item, i) in notFoundTransportIds" :key="i" @click="viewItem({transportId: item})">
                        {{ item }}
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-dialog>


                  <v-spacer></v-spacer>
                  <v-text-field
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                    v-model="search"
                  ></v-text-field>
              </v-toolbar>
              <v-card-title class="primary--text">
                <div class="headline">{{ selectedInvoice.firstname }} {{ selectedInvoice.lastname }}</div>
              </v-card-title>
              <v-data-table
                  ref="bookings"
                  :headers="headers_bookings"
                  :items="filteredBookings"
                  :options.sync="pagination"
                  :sort-by="['ap_date']"
                  :sort-desc="[true]"
                  :footer-props="{ 'items-per-page-options': [{text:'All', value:-1}, 10, 20, 30] }"
                >
                <template v-slot:body="{ items }" >
                  <tbody>
                  <tr v-for="item in items" :key="item.id" :class="'status-' + item.status">

                  <td >{{ item.id }}</td>
                  <td>{{ item.mutualPatientID }}</td>
                  <td >{{ item.ap_date }}</td>
                  <td >{{ item.ap_time | formatTime }}</td>
                  <td >{{ item.client_lastname + ' ' + item.client_firstname}}</td>
                  <td >{{ item.destination_name }}</td>
                  <td >{{ item.type }}</td>
                  <td class="no-break">{{ item.mutualAmount | currency }}</td>
                  <td class="no-break">{{ item.mutualPatientAmount | currency }}</td>
                  <td>
                    <div style="display: flex">
                    <v-icon
                      small
                      class="mr-2"
                      @click="viewItem({transportId: item.mutualPatientID})"
                    >
                      visibility
                    </v-icon>
                    <v-icon
                      small
                      class="mr-2"
                      color="primary"
                      @click="editItem(item)"
                    >
                      edit
                    </v-icon>
                    </div>

                  </td>

                  </tr>
                  </tbody>
                </template>
                <template slot="pageText" slot-scope="{ pageStart, pageStop }">
                  From {{ pageStart }} to {{ pageStop }}
                </template>
              </v-data-table>
          </v-card>
        </v-flex>



      </v-layout>
    </div>
	</m-layout>
</template>
<script>
import moment from 'moment';
import BookingMixin from '@/mixins/bookings'
import Invoice from '@/components/wallet/booqit.vue'
import { searchItems } from '@/utils/helpers'

export default {
  name: 'booqitInvoices',
  mixins: [BookingMixin],
  components: {
    'm-invoice': Invoice
  },
  data () {
    return {
      loading: false,
      dialog_loader: false,
      dialog_invoice: false,
      dialog_notFound: false,
      pagination_invoices: {},
      pagination: {},
      search_invoices: '',
      search: '',
      booqitInvoices: [],
      filteredItems: [],
      reverseSearch: false,
      bookings: [],
      selectedInvoice: {},
      selectedItem: {},
      notFoundTransportIds: [],
      headers: [
        { text: 'Date', value: 'date' },
        { text: 'Invoice ID', value: 'invoiceId' },
        { text: 'Amount', value: 'amount' }
      ],
      headers_bookings: [
        {
          text: 'ID',
          align: 'left',
          width: '10',
          value: 'id'
        },
        { width: '30', text: 'Transp. id', value: 'mutualPatientId' },
        { width: '20', text: '​Date', value: 'ap_date' },
        { width: '20', text: '​Time', value: 'ap_time' },
        { text: 'Client', value: 'client_lastname' },
        { text: '​Destination', value: 'destination_name' },
        { width: '30', text: 'Type', value: 'type' },
        { width: '40', text: 'Price', value: 'mutualAmount' },
        { width: '50', text: 'Patient', value: 'mutualPatientAmount' }
      ],
      booqitUrl: 'https://booqitapp.com/?transportId='
    }
  },
  methods: {
    onRefresh () {
      this.onSelect(this.selectedInvoice);
    },
    onRefreshAll () {
      this.getBooqitInvoices();
    },
    onSelect (item) {
      this.selectedInvoice = item;
      this.getBookingByTransportIds(item.transportIds);
    },
    onFactuurItem (item) {
      this.selectedInvoice = item;
      this.dialog_invoice = true;
    },
    viewItem (item) {
      if (item.transportId) {
        window.open(this.booqitUrl + item.transportId, '_blank');
      }
    },
    editItem (item) {
      this.resetBooking();
      this.selectedItem = this.bookings.find(i => i === item);
      this.dialog_edit = true;
      console.log('edit', this.selectedInvoice.id);
    },
    onClose () {
      this.dialog_invoice = false;
    },
    loadData () {
      if (localStorage.getItem('booqitInvoices')) {
        this.booqitInvoices = JSON.parse(localStorage.getItem('booqitInvoices'));
        // console.log(this.booqit);
      }
    },
    getBooqitInvoices () {
      this.dialog_loader = true;
      this.selectedInvoice = {};
      this.$http
        .get('service/booqit/invoices')
        .then(response => {
          // app.map.renderData(response.data)
          // console.log('inbox response data', response.data);
          // this.parseInvoices(response, 'invoices');
          console.log('invoices response data', response.data);
          this.parseBooqit(response.data);
          this.dialog_loader = false;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
    },
    getBookingByTransportIds (transportIds) {
      var app = this;
      this.loading = true;
      this.$http
      .post('service/booking/byTransportIds', {transportIds})
      .then(response => {
        console.log('getBookingByTransportIds data', response.data);
        app.bookings = response.data;
        app.bookings.map(function (d) {
          d.date = d.ap_date
          d.json = JSON.parse(d.distance)
          d.ap_date = app.$options.filters.date(d.ap_date)
        })
        this.loading = false;
        this.checkTransportIds(transportIds);
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    parseBooqit (data) {
      if (data) {
        this.booqitInvoices = [];
        data.forEach(item => {
          var invoice = {
            invoiceId: item.invoiceNumber,
            date: item.createdAt,
            amount: item.totals.totalExcl,
            transportIds: item.transportIds
          }
          this.booqitInvoices.push(invoice)
        });
      }
    },
    checkTransportIds (transportIds) {
      this.notFoundTransportIds = transportIds.filter((e) => {
        return !this.bookings.some(b => b.mutualPatientID === e)
      })
      console.log('notFound: ', this.notFoundTransportIds);
    }
  },
  watch: {
    booqitInvoices: {
      handler (updatedList) {
        console.log('updated localStorage');
        localStorage.setItem('booqitInvoices', JSON.stringify(updatedList));
      },
      deep: true
    }
  },
  filters: {
    date: function (date) {
      return moment(date).format('DD/MM/YYYY');
    },
    formatIndex (v, obj) {
      return obj[v];
    },
    toTime (sec) {
      var time;
      if (sec > 3600) {
        time = new Date(sec * 1000).toISOString().substr(11, 5) + ' h'
      } else {
        time = new Date(sec * 1000).toISOString().substr(14, 2) + ' mins'
      }
      return time;
    }
  },
  computed: {
    filteredBookings () {
      return searchItems(this.bookings, this.search, this.reverseSearch) || this.bookings;
    },
    totalAmount () {
      return this.filteredBookings.reduce((sum, a) => sum + Number(a.mutualAmount) - Number(a.mutualPatientAmount), 0);
    }
  },
  mounted () {
    this.loadData();
  }
}
</script>
<style lang="scss">
  .no-break {
    white-space: nowrap;
  }
  .v-list-item.m-selectable {
    font-size: 14px;
    user-select: text;
  }
</style>
